import { Injectable, Injector } from '@angular/core';
import { BaseResourceService, ContratoTerceirizado } from 'eddydata-lib';

@Injectable({
  providedIn: 'root'
})
export class ContratoTerceirizadoService extends BaseResourceService<ContratoTerceirizado> {

  constructor(
    protected injector: Injector
  ) {
    super(`contrato-tercerizados`, injector);
  }

}